import React, { useState } from 'react'

const HoverDropdown = ({ title, items }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleMouseEnter = () => {
        setIsOpen(true)
    }

    const handleMouseLeave = () => {
        setIsOpen(false)
    }

    return (
        <div
            className="hoverDropdown"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="dropdownTitle" style={isOpen ? { color: '#ed1c24' } : {}}>
                {title}
                <span className="material-icons">
                    {isOpen ? 'arrow_drop_up' : 'arrow_drop_down'}
                </span>
            </div>
            {isOpen && (
                <ul className="dropdownMenu">
                    {items.map((item, index) => (
                        <li key={index} className="dropdownItem" onClick={item.onClick}>
                            {item.icon && <span className="material-icons">{item.icon}</span>}
                            {item.image && <img src={item.image} alt={item.label} />}
                            {item.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default HoverDropdown
